var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 272,
    viewBox: "0 0 250 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_2_102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 2,
    width: 90,
    height: 90,
    rx: 20,
    fill: "#F2B8EC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.479 60V39.9939H115V60H118.838V58.8131C118.838 57.3207 120.009 56.1043 121.426 56.1043H125.052C126.471 56.1043 127.65 57.3207 127.65 58.8131V60H131.479ZM119.55 52.8478C119.55 52.954 119.531 53.0644 119.492 53.1624C119.454 53.2604 119.4 53.351 119.329 53.4263C119.258 53.5013 119.172 53.5581 119.079 53.5987C118.986 53.6393 118.881 53.6594 118.78 53.6594H116.962C116.862 53.6594 116.757 53.6393 116.664 53.5987C116.571 53.5581 116.485 53.5013 116.414 53.4263C116.343 53.3513 116.289 53.2608 116.251 53.1624C116.212 53.0644 116.193 52.9543 116.193 52.8478V50.9506C116.193 50.8445 116.212 50.7344 116.251 50.636C116.289 50.538 116.343 50.4474 116.414 50.3721C116.485 50.2971 116.571 50.2403 116.664 50.1997C116.757 50.1591 116.862 50.1387 116.962 50.1387H118.78C118.881 50.1387 118.985 50.1588 119.079 50.1997C119.172 50.2403 119.258 50.2971 119.329 50.3721C119.4 50.4474 119.454 50.5377 119.492 50.636C119.531 50.7341 119.55 50.8441 119.55 50.9506V52.8478ZM119.55 47.2374C119.55 47.3435 119.531 47.4536 119.492 47.5519C119.454 47.65 119.4 47.7406 119.329 47.8155C119.258 47.8909 119.172 47.9473 119.079 47.9879C118.986 48.0285 118.881 48.049 118.78 48.049H116.962C116.862 48.049 116.757 48.0288 116.664 47.9879C116.571 47.9473 116.485 47.8905 116.414 47.8155C116.343 47.7406 116.289 47.65 116.251 47.5519C116.212 47.4539 116.193 47.3435 116.193 47.2374V45.3301C116.193 45.2239 116.212 45.1239 116.251 45.0256C116.289 44.9275 116.343 44.837 116.414 44.7616C116.485 44.6866 116.571 44.6198 116.664 44.5789C116.757 44.5383 116.862 44.5178 116.962 44.5178H118.78C118.881 44.5178 118.985 44.538 119.079 44.5789C119.172 44.6194 119.258 44.6863 119.329 44.7616C119.4 44.8366 119.454 44.9272 119.492 45.0256C119.531 45.1236 119.55 45.2236 119.55 45.3301V47.2374ZM121.561 45.2389C121.561 45.1327 121.58 45.0226 121.619 44.9243C121.657 44.8262 121.711 44.7357 121.782 44.6603C121.853 44.5854 121.939 44.5285 122.032 44.488C122.125 44.4474 122.23 44.4273 122.331 44.4273H123.956C124.057 44.4273 124.161 44.4474 124.255 44.488C124.347 44.5285 124.433 44.5854 124.505 44.6603C124.576 44.7353 124.63 44.8259 124.668 44.9243C124.707 45.0223 124.726 45.1324 124.726 45.2389V46.9432C124.726 47.0494 124.707 47.1494 124.668 47.2474C124.63 47.3455 124.576 47.436 124.505 47.5114C124.434 47.5863 124.348 47.6532 124.255 47.6938C124.162 47.7344 124.057 47.7548 123.956 47.7548H122.331C122.23 47.7548 122.125 47.7347 122.032 47.6938C121.939 47.6532 121.853 47.5863 121.782 47.5114C121.711 47.4364 121.657 47.3458 121.619 47.2474C121.58 47.1494 121.561 47.0494 121.561 46.9432V45.2389ZM124.774 52.6043C124.774 52.7105 124.754 52.8105 124.716 52.9088C124.677 53.0069 124.623 53.0975 124.552 53.1725C124.481 53.2478 124.395 53.3143 124.302 53.3552C124.209 53.3958 124.105 53.4159 124.004 53.4159H122.33C122.229 53.4159 122.125 53.3958 122.032 53.3552C121.939 53.3147 121.853 53.2478 121.781 53.1725C121.71 53.0975 121.656 53.0069 121.618 52.9088C121.58 52.8108 121.56 52.7108 121.56 52.6043V50.8493C121.56 50.7432 121.579 50.6331 121.618 50.5347C121.656 50.4367 121.71 50.3461 121.781 50.2711C121.853 50.1961 121.938 50.1393 122.032 50.0987C122.125 50.0582 122.229 50.0377 122.33 50.0377H124.004C124.105 50.0377 124.209 50.0578 124.302 50.0987C124.395 50.1393 124.481 50.1961 124.552 50.2711C124.624 50.3461 124.677 50.4367 124.716 50.5347C124.754 50.6331 124.774 50.7432 124.774 50.8493V52.6043ZM126.928 45.3301C126.928 45.2239 126.947 45.1239 126.986 45.0256C127.025 44.9275 127.079 44.837 127.15 44.7616C127.221 44.6866 127.307 44.6198 127.4 44.5789C127.493 44.5383 127.597 44.5178 127.698 44.5178H129.516C129.617 44.5178 129.721 44.538 129.814 44.5789C129.907 44.6194 129.993 44.6863 130.064 44.7616C130.136 44.8366 130.189 44.9272 130.228 45.0256C130.266 45.1236 130.285 45.2236 130.285 45.3301V47.2374C130.285 47.3435 130.266 47.4536 130.228 47.5519C130.189 47.65 130.136 47.7406 130.064 47.8155C129.993 47.8909 129.907 47.9473 129.814 47.9879C129.721 48.0285 129.617 48.049 129.516 48.049H127.698C127.597 48.049 127.493 48.0288 127.4 47.9879C127.307 47.9473 127.221 47.8905 127.15 47.8155C127.078 47.7406 127.025 47.65 126.986 47.5519C126.948 47.4539 126.928 47.3435 126.928 47.2374V45.3301ZM127.4 53.5984C127.307 53.5578 127.221 53.501 127.15 53.426C127.079 53.351 127.025 53.2604 126.986 53.1621C126.948 53.064 126.929 52.954 126.929 52.8475V50.9506C126.929 50.8445 126.948 50.7344 126.986 50.636C127.025 50.538 127.079 50.4474 127.15 50.3721C127.221 50.2971 127.307 50.2403 127.4 50.1997C127.493 50.1591 127.598 50.1387 127.698 50.1387H129.516C129.617 50.1387 129.721 50.1588 129.815 50.1997C129.907 50.2403 129.993 50.2971 130.065 50.3721C130.136 50.4474 130.19 50.5377 130.228 50.636C130.267 50.7341 130.286 50.8441 130.286 50.9506V52.8478C130.286 52.954 130.267 53.0644 130.228 53.1624C130.19 53.2604 130.136 53.351 130.065 53.4263C129.994 53.5013 129.908 53.5581 129.815 53.5987C129.722 53.6393 129.617 53.6594 129.516 53.6594H127.698C127.597 53.6594 127.493 53.639 127.4 53.5984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.953 35H119.081L116.03 38.3698H131.89L134.953 35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.017 58.7846L136 55.4907V36.1937L133.017 39.4758V58.7846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.424 57.7239C120.841 57.7239 120.375 58.2164 120.375 58.8147V59.9974H126.106V58.8147C126.106 58.2164 125.642 57.7239 125.054 57.7239H121.424Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_2_102",
    x: 0,
    y: 0.703704,
    width: 250,
    height: 271.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_102",
    result: "effect2_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2_102",
    result: "effect3_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2_102",
    result: "effect4_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64.8148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2_102",
    result: "effect5_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2_102",
    result: "effect6_dropShadow_2_102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2_102",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/Property.dd47d75b9f389996345e13d8201d5629.svg";
export { ForwardRef as ReactComponent };